export interface SpaService {
    serviceId: string;
    translationKey: string;
    imageUrl: string;
    priceBoxId: string;
    serviceNameId: string;
    serviceDescId: string;
    serviceCtaId: string;
    category: 'massage' | 'sauna' | 'pelvipower';
}

/** Temporarily hide massage treatments while massage rooms are under maintenance. */
export const SHOW_THERAPEUTIC_MASSAGES = false;

export const spaServices: SpaService[] = [
    {
        serviceId: "service-1",
        translationKey: "spa.treatmentsAndServices.therapeuticMassages.fullBody",
        imageUrl: "/images/Clinique Nutraswiss/massage images/Full body.jpg",
        priceBoxId: "price-duration-box-1",
        serviceNameId: "service-name-1",
        serviceDescId: "service-desc-1",
        serviceCtaId: "service-cta-1",
        category: 'massage'
    },
    {
        serviceId: "service-2",
        translationKey: "spa.treatmentsAndServices.therapeuticMassages.relaxing",
        imageUrl: "/images/Clinique Nutraswiss/massage images/Relaxing Massage.jpg",
        priceBoxId: "price-duration-box-2",
        serviceNameId: "service-name-2",
        serviceDescId: "service-desc-2",
        serviceCtaId: "service-cta-2",
        category: 'massage'
    },
    {
        serviceId: "service-3",
        translationKey: "spa.treatmentsAndServices.therapeuticMassages.sport",
        imageUrl: "/images/Clinique Nutraswiss/massage images/Sport Massage.jpg",
        priceBoxId: "price-duration-box-3",
        serviceNameId: "service-name-3",
        serviceDescId: "service-desc-3",
        serviceCtaId: "service-cta-3",
        category: 'massage'
    },
    {
        serviceId: "service-4",
        translationKey: "spa.treatmentsAndServices.therapeuticMassages.footReflexology",
        imageUrl: "/images/Clinique Nutraswiss/massage images/Foot Reflexology massage.jpg",
        priceBoxId: "price-duration-box-4",
        serviceNameId: "service-name-4",
        serviceDescId: "service-desc-4",
        serviceCtaId: "service-cta-4",
        category: 'massage'
    },
    {
        serviceId: "service-5",
        translationKey: "spa.treatmentsAndServices.therapeuticMassages.footBack",
        imageUrl: "/images/Clinique Nutraswiss/massage images/Foot and back massage.jpg",
        priceBoxId: "price-duration-box-5",
        serviceNameId: "service-name-5",
        serviceDescId: "service-desc-5",
        serviceCtaId: "service-cta-5",
        category: 'massage'
    },
    {
        serviceId: "service-6",
        translationKey: "spa.treatmentsAndServices.therapeuticMassages.backNeck",
        imageUrl: "/images/Clinique Nutraswiss/massage images/back and neck pain.jpg",
        priceBoxId: "price-duration-box-6",
        serviceNameId: "service-name-6",
        serviceDescId: "service-desc-6",
        serviceCtaId: "service-cta-6",
        category: 'massage'
    },
    {
        serviceId: "service-7",
        translationKey: "spa.treatmentsAndServices.therapeuticMassages.peeling",
        imageUrl: "/images/Clinique Nutraswiss/massage images/peeling and full body massage.jpg",
        priceBoxId: "price-duration-box-7",
        serviceNameId: "service-name-7",
        serviceDescId: "service-desc-7",
        serviceCtaId: "service-cta-7",
        category: 'massage'
    },
    {
        serviceId: "service-8",
        translationKey: "spa.treatmentsAndServices.therapeuticMassages.energetic",
        imageUrl: "/images/Clinique Nutraswiss/massage images/Energetic massage.jpg",
        priceBoxId: "price-duration-box-8",
        serviceNameId: "service-name-8",
        serviceDescId: "service-desc-8",
        serviceCtaId: "service-cta-8",
        category: 'massage'
    },
    {
        serviceId: "sauna-package",
        translationKey: "spa.treatmentsAndServices.saunaThermal.package",
        imageUrl: "/images/Clinique Nutraswiss/Sauna package images/Finnish Sauna.jpg",
        priceBoxId: "price-sauna-package",
        serviceNameId: "name-sauna-package",
        serviceDescId: "desc-sauna-package",
        serviceCtaId: "cta-sauna-package",
        category: 'sauna'
    },
    {
        serviceId: "pelvipower",
        translationKey: "spa.treatmentsAndServices.specialPrograms.pelvipower",
        imageUrl: "/images/Clinique Nutraswiss/pelvipower.jpeg",
        priceBoxId: "price-pelvipower",
        serviceNameId: "name-pelvipower",
        serviceDescId: "desc-pelvipower",
        serviceCtaId: "cta-pelvipower",
        category: 'pelvipower'
    },
];

export const saunaFacilities = [
    {
        name: "spa.treatmentsAndServices.saunaThermal.finnish.name",
        tempKey: "spa.treatmentsAndServices.saunaThermal.finnish.temperature",
        description: "spa.treatmentsAndServices.saunaThermal.finnish.description",
        image: "/images/Clinique Nutraswiss/Sauna package images/Finnish Sauna.jpg",
        category: 'sauna' as const
    },
    {
        name: "spa.treatmentsAndServices.saunaThermal.bio.name",
        tempKey: "spa.treatmentsAndServices.saunaThermal.bio.temperature",
        description: "spa.treatmentsAndServices.saunaThermal.bio.description",
        image: "/images/Clinique Nutraswiss/Sauna package images/Bio Sauna.jpg",
        category: 'sauna' as const
    },
    {
        name: "spa.treatmentsAndServices.saunaThermal.steam.name",
        tempKey: "spa.treatmentsAndServices.saunaThermal.steam.temperature",
        description: "spa.treatmentsAndServices.saunaThermal.steam.description",
        image: "/images/Clinique Nutraswiss/Sauna package images/Steam Bath.jpg",
        category: 'sauna' as const
    },
    {
        name: "spa.treatmentsAndServices.saunaThermal.icePlunge.name",
        tempKey: "", // Special case for ice plunge temp
        tempValue: "0-5°C",
        description: "spa.treatmentsAndServices.saunaThermal.icePlunge.description",
        image: "/images/Clinique Nutraswiss/Sauna package images/Ice bath.jpg",
        category: 'sauna' as const
    }
];
